import React from 'react';
import { Paper, Grid, Typography } from '@mui/material';

const GpuClassDetail = ({ details }) => {
  if (!details) return null;
  
  const { name, price, performance } = details;

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 2 }}>
          <Typography variant='h5'>{name}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 8 }}>
          <Typography variant='h6' gutterBottom>
            Performance
          </Typography>
          <Grid container spacing={2}>
            <Grid size={6}>
              <Typography>
                Single Prec (FP32): <b>{performance.fp32_rate} TFLOPS</b>
              </Typography>
              <Typography>
                Half Prec (FP16): <b>{performance.fp16_rate} TFLOPS</b>
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography>
                Double Prec (FP64): <b>{performance.fp64_rate} TFLOPS</b>
              </Typography>
              <Typography>
                Integer (INT8): <b>{performance.int8_rate} TOPS</b>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, sm: 2 }}>
          <Typography variant='h6' gutterBottom>
            Memory
          </Typography>
          <Typography>
            Size: <b>{performance.memory_size} GB</b>
          </Typography>
          <Typography>
            Bandwidth: <b>{performance.memory_bandwidth} GB/S</b>
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 2 }}>
          <Typography variant='h6' gutterBottom>
            Pricing
          </Typography>
          <Typography>
            Credits Per Hour: <b>{price.max}</b>
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default GpuClassDetail;

